//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsMediaLibraryPageEnabled = createHasFeatureSelector(
  FeatureNames.MediaLibraryPage,
);

export const getIsMediaLibrarySourcedOrganicContentEnabled =
  createHasFeatureSelector(FeatureNames.MediaLibrarySourcedOrganicContent);

export const getIsTributarySelfServeEnabled = createHasFeatureSelector(
  FeatureNames.TributarySelfServe,
);

// TODO: PD-297467 - Remove content_library_products_improvements feature flag
export const getIsContentLibraryProductsImprovementsEnabled =
  createHasFeatureSelector(FeatureNames.ContentLibraryProductsImprovements);

// TODO: PD-299041 - Remove content_library_filters_improvements feature flag
export const getIsContentLibraryFiltersImprovementsEnabled =
  createHasFeatureSelector(FeatureNames.ContentLibraryFiltersImprovements);

// TODO: PD-299277 - Remove content_library_campaign_filters feature flag
export const getIsContentLibraryCampaignFiltersEnabled =
  createHasFeatureSelector(FeatureNames.ContentLibraryCampaignFilters);
